import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "api";
import { STATUS } from "utils/status";
import { GetPayload, ReviewerState } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/reviewerExtraReducer';

const initialState: ReviewerState = {
  reviewer: {},
  customPushbackStage:{},
  configsReview:{},
  error: null,
  createReviewStatus: STATUS.NOT_STARTED,
  getReviewStatus: STATUS.NOT_STARTED,
  updateReviewStatus: STATUS.NOT_STARTED,
  getReviewToReviewStatus: STATUS.NOT_STARTED,
  getReviewCustomPushbackStageStatus: STATUS.NOT_STARTED,
  getCommonIdentifiersStatus: STATUS.NOT_STARTED,
  createReviewMessage: "",
  getReviewMessage: "",
  updateReviewMessage: "",
  selectedStageId: null,
  commonIdentifiers: {},
};

export const createReview = createAsyncThunk(
  'project/company/stage/POST',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.post('project/company/stage/', payload);
      const { status, data } = response;
      if (status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue({ message: error.response.data.message });
    }
  }
)

export const getReviewCustomPushbackStage = createAsyncThunk(
  'project/company/stage/previous/backtrack/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    try {
      const { search, page, pageSize, sort, order, id, fields, paginate, project_id, category, stage_id } = payload;
      const response = await api.get('project/company/stage/previous/backtrack', {
        params: {
          ...(id && { id }),
          ...(project_id && { project_id }),
          ...(stage_id && { stage_id }),
          ...(search && { search }),
          ...(category && { category }),
          ...(page && { page }),
          ...(pageSize && { page_size: pageSize }),
          ...(paginate && { paginate }),
          ...(sort && { sort }),
          ...(order && { order }),
          ...(fields && { fields }),
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    }
    catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

export const getReview = createAsyncThunk(
  'project/company/stage/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    try {
      const { search, page, pageSize, sort, order, id, fields, paginate, project_id, category, association_type } = payload;
      const response = await api.get('project/company/stage/', {
        params: {
          ...(id && { id }),
          ...(project_id && { project_id }),
          ...(association_type && { association_type }),
          ...(search && { search }),
          ...(category && { category }),
          ...(page && { page }),
          ...(pageSize && { page_size: pageSize }),
          ...(paginate && { paginate }),
          ...(sort && { sort }),
          ...(order && { order }),
          ...(fields && { fields }),
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    }
    catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

export const getReviewToReview = createAsyncThunk(
  'project/company/stage/configs/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    try {
      const { search, page, pageSize, sort, order, id, fields, paginate, project_id, category, stage_id } = payload;
      const response = await api.get('project/company/stage/configs', {
        params: {
          ...(id && { id }),
          ...(project_id && { project_id }),
          ...(stage_id && { stage_id }),
          ...(search && { search }),
          ...(category && { category }),
          ...(page && { page }),
          ...(pageSize && { page_size: pageSize }),
          ...(paginate && { paginate }),
          ...(sort && { sort }),
          ...(order && { order }),
          ...(fields && { fields }),
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    }
    catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

export const updateReview = createAsyncThunk(
  'project/company/stage/patch',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.patch(`project/company/stage/`, payload);
      const { status, data } = response;
      if (status === 200) {
        return { data, payload };
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {

      return thunkAPI.rejectWithValue({ message: error.response.data.message });

    }
  }
);


export const getCommonIdentifiers = createAsyncThunk(
  'project/company/config/common-identifiers/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    try {
      const { project_id, stage_id } = payload;
      const response = await api.get('project/company/config/common-identifiers', {
        params: {
          ...(project_id && { project_id }),
          ...(stage_id && { stage_id }),
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    }
    catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);



const addReviewerSlice = createSlice({
  name: 'reviewers',
  initialState,
  reducers: {
    setCreateReviewStatus(state, action) {
      state.createReviewStatus = action.payload
    },
    setUpdateReviewStatus(state, action) {
      state.updateReviewStatus = action.payload
    },
    setSelectedStageId(state, action) {
      state.selectedStageId = action.payload;
    },
  },
  extraReducers
});

export const { setCreateReviewStatus, setUpdateReviewStatus, setSelectedStageId } = addReviewerSlice.actions;
export default addReviewerSlice.reducer;


